import externalLinkIcon from '@/assets/images/external_link.svg';
import logo from '@/assets/images/globis_logo.svg';
import userIcon from '@/assets/images/user_icon.svg';
import { GLOPLA_PARTICIPANT_HOST, INQUIRY_URL } from '@/constant';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Link } from '@tanstack/react-router';
import React from 'react';
import styles from './index.module.scss';

export type HeaderProps = {
  userName?: string;
  onLogout: () => Promise<void>;
};

export const Header = ({ userName, onLogout }: HeaderProps) => {
  return (
    <header className={styles.header}>
      <h1 className={styles.logo}>
        <Link to="/">
          <img src={logo} alt="GLOBIS" />
        </Link>
      </h1>

      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <div className={styles.nameArea}>
            <p className={styles.name}>{userName}</p>
            <img
              className={styles.userIcon}
              src={userIcon}
              alt="ユーザーアイコン"
            />
          </div>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content
            className={styles.userMenu}
            sideOffset={10}
            alignOffset={0}
            align={'end'}
          >
            <DropdownMenu.Item className={styles.userMenuItem}>
              <a
                href={`${GLOPLA_PARTICIPANT_HOST}/update-profile`}
                target="_blank"
                rel="noreferrer"
              >
                <span>ユーザー情報</span>
                <img src={externalLinkIcon} alt="" />
              </a>
            </DropdownMenu.Item>
            <DropdownMenu.Item className={styles.userMenuItem}>
              <a href={INQUIRY_URL} target="_blank" rel="noreferrer">
                <span>FAQ/お問い合わせ</span>
                <img src={externalLinkIcon} alt="" />
              </a>
            </DropdownMenu.Item>
            <DropdownMenu.Item className={styles.userMenuItem}>
              <Link
                to="/select-user-enrollment"
                search={{ disableAutoSelect: true }}
              >
                <span>開講データ選択</span>
              </Link>
            </DropdownMenu.Item>
            <DropdownMenu.Item className={styles.userMenuItem}>
              <button onClick={onLogout} type="button">
                <span>ログアウト</span>
              </button>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </header>
  );
};
